import PropTypes from 'prop-types';
import { Autocomplete } from '@mui/material';
import { Input } from '../index';

function LabPicker({
    labs,
    selectedLab,
    onSelectLab,
    disabled,
    includeNone,
    returnObject,
    required,
    errorText,
}) {
    const options = includeNone ? [{ id: 'none', name: 'None' }, ...labs] : labs;

    return (
        <Autocomplete
            disabled={disabled}
            className="form-field"
            options={options}
            renderInput={(props) => (
                <Input {...props} error={errorText} helperText={errorText} label={`Labs ${required ? '*' : ''}`} />
            )}
            renderOption={(props, option) => (
                <li {...props} key={option.id}>
                    {option.name}
                </li>
            )}
            getOptionLabel={(option) => option?.name || ''}
            value={options.find((lab) => lab.id === selectedLab) || null}
            onChange={(event, newValue) => {
                if (returnObject) onSelectLab(newValue);
                else onSelectLab(newValue?.id || '');
            }}
        />
    );
}

LabPicker.propTypes = {
    labs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
    })).isRequired,
    selectedLab: PropTypes.string,
    onSelectLab: PropTypes.func,
    disabled: PropTypes.bool,
    includeNone: PropTypes.bool,
    returnObject: PropTypes.bool,
    required: PropTypes.bool,
    errorText: PropTypes.string,
};

LabPicker.defaultProps = {
    selectedLab: '',
    onSelectLab: () => {},
    disabled: false,
    includeNone: false,
    returnObject: false,
    required: false,
    errorText: '',
};

export default LabPicker;
